import AvidIcon from './img/avid-icon.png';

const LogoIcon = () => {
  return <img src={AvidIcon} alt="AvidXchange" height="28" />;
};

export default LogoIcon;
